import React from 'react';
import { Box, Button } from '@spothero/ui';
import CancellationInfo from 'common/cancellation-info';
import Price from 'common/price';
import AvailableInventory from '../available-inventory-message';
const AirportPurchaseSnapshot = ({ cancellationAllowed, displayPrice, currencyType, availableTransientInventory, checkoutDisabled, onCheckoutClick, onShowPriceBreakdownModal, }) => {
    return (<div className="AirportPurchaseSnapshot">
            <Box height={8} paddingX={4} paddingY={2} borderBottomWidth="1px" borderColor="gray.200">
                <CancellationInfo cancellationAllowed={cancellationAllowed}/>
            </Box>
            <div className="AirportPurchaseSnapshot-price-container">
                <div className="AirportPurchaseSnapshot-price-inventory">
                    <div className="AirportPurchaseSnapshot-price">
                        <Price amount={displayPrice} currencyType={currencyType}/>
                        <Button variant="tertiary" onClick={onShowPriceBreakdownModal} paddingLeft={1} fontWeight="normal" color="black" textDecoration="underline">
                            <span>Total</span>
                        </Button>
                    </div>
                    <AvailableInventory availableTransientInventory={availableTransientInventory}/>
                </div>

                <Button variant="primary" isDisabled={checkoutDisabled} onClick={onCheckoutClick}>
                    Book Now
                </Button>
            </div>
        </div>);
};
export default AirportPurchaseSnapshot;
